import { render, staticRenderFns } from "./EventPermissionPicker.vue?vue&type=template&id=56436057&scoped=true"
import script from "./EventPermissionPicker.js?vue&type=script&lang=js&external"
export * from "./EventPermissionPicker.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56436057",
  null
  
)

export default component.exports